import React from 'react';
import styled from 'styled-components';
import { Heading3, P, Margin } from '@ovotech/element-v5';
import { BeyondProgress } from './BeyondProgress';
import { useBeyondAccountFlags } from '@/src/hooks/useBeyondAccountFlags/useBeyondAccountFlags';

import { RewardsCard } from './RewardsCard';

const Heading = styled(Heading3)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

export const NearlyThere = () => {
  const { hasSmartMeter, hasDirectDebit } = useBeyondAccountFlags();

  const getContent = () => {
    if (hasSmartMeter && hasDirectDebit) {
      return {
        heading: "You're ready for Beyond",
        paragraph:
          'You have a smart meter and pay by Direct Debit. To start using your rewards, you just need the app.',
      };
    }
    if (hasSmartMeter && !hasDirectDebit) {
      return {
        heading: "You're nearly there",
        paragraph:
          "It's easy to set up, and you can adjust your monthly payments anytime.",
      };
    }
    if (!hasSmartMeter && hasDirectDebit) {
      return {
        heading: "You're nearly there",
        paragraph: 'You just need a smart meter to unlock rewards in the app.',
      };
    }
    return {
      heading: 'Unlock Beyond in 3 steps',
      paragraph:
        "You'll need a smart meter and Direct Debit to unlock rewards in the app.",
    };
  };

  const { heading, paragraph } = getContent();

  return (
    <RewardsCard>
      <Heading>{heading}</Heading>
      <Margin top={3}>
        <P size="md">{paragraph}</P>
      </Margin>

      <Margin right={6}>
        <BeyondProgress />
      </Margin>
    </RewardsCard>
  );
};
